import $ from "jquery";
import { u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import addFuncHeader from "./_funcHeader";
import addFm from "./_fm";

const { app } = window;

// [editSection] VuwFade
// 編集フォームを持つコンポーネント
!!vuwer.get("pageMain") && vuwer.add("editSection", {
	vuwType: "fade",
	
	selector() {
		return $("<div/>").addClass("section vuw-fade").attr({
			"id": "edit_section",
			"data-section": "edit",
			"data-visible": "0"
		}).appendTo( vuwer.get("pageMain").$self );
	},
	
	onReady($self) {
		this.$content = $("<div/>").addClass("content").appendTo($self);
	},
	
	async refresh() {
		const methods = [];
		this.getChildren().forEach(vuw => {
			u_.isFunction(vuw.refresh) && methods.push( vuw.refresh() );
		});
		return Promise.all(methods);
	},
	
	onChangeState(state) {
		if( !app.isWaitingLogin() ) {// ※ログイン待ちの場合は以下の処理をスキップ
			if(
				state.visible !== this.state.visible ||
				state.contentKeyChanged
			) {
				const fm = this.get("fm");
				
				if(state.visible) {
					// 入力formを更新
					const { items } = app.module;
					const { itemId } = state;
					
					if( itemId && u_.isString(itemId) && items.byId && items.byId[itemId] ) {
						fm.setVal( items.byId[itemId] );
					} else {
						fm.clearVal();
					}
					
				} else
				if( fm.getActiveSheetIdx() > 0 ) {
					return fm.setActiveSheet(0);
				}
			}
		}
	}
}, function() {
	addFuncHeader(this);
	addFm(this);
});
